// 01-10 for showing cordinate
import React, { useContext, useEffect, useState } from "react";
import submitIcon from "../../../../public/LoginImages/submit.png";
import cancelIcon from "../../../../public/LoginImages/Cancel32.png";
import AdminContext from "../../StateContext/Application";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Popup,
  Polygon,
  useMapEvents,
  useMap //14-10 for selected cordinate
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
// Leaflet Marker Icon Fix — this stays at module scope, it's not a hook.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",

  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",

  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});
  {/* //Map coordinate update */}
const formatCoord = (pos) => (pos ? `${pos[0]}, ${pos[1]}` : "");

// const selectStyle = {
//   borderRadius: "10px",
//   width: "100%",
//   padding: "10px 14px",
//   border: "1px solid #c2d4e9",
//   fontSize: "13px",
//   fontWeight: "500",
//   background: "#fff",
// };





// 05-10 for dropdown icon
const selectStyle = {
  borderRadius: "10px",
  width: "100%",
  padding: "10px 14px",
  paddingRight: "40px",
  border: "1px solid #c2d4e9",
  fontSize: "13px",
  fontWeight: "500",
  background: "#fff",
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  backgroundImage:
    'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M4 6l4 4 4-4%27 fill=%27none%27 stroke=%27%23000000%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E")',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 14px center",
  backgroundSize: "16px",
};

// const boxStyle = {
//   ...selectStyle,
//   minHeight: "42px",
//   display: "flex",
//   alignItems: "center",
// };
// 05-10
const boxStyle = {
  borderRadius: "10px",
  width: "100%",
  padding: "10px 14px",
  minHeight: "42px",
  border: "1px solid #c2d4e9",
  fontSize: "13px",
  fontWeight: "500",
  background: "#fff",
  display: "flex",
  alignItems: "center",
};
 

const labelStyle = {
  fontSize: "13px",
  fontWeight: "600",
  color: "#000",
  marginBottom: "6px",
};

const MapClickHandler = ({ clickPositions, setClickPositions }) => {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;

      if (clickPositions.length < 2) {
        if (clickPositions.length === 1) {
          const [prevLat, prevLng] = clickPositions[0];
          const distance = Math.sqrt(
            Math.pow(lat - prevLat, 2) + Math.pow(lng - prevLng, 2)
          );
          if (distance < 0.00001) {
            alert("Start and End point cannot be the same. Please select a different point.");
            return;
          }
        }
        setClickPositions([...clickPositions, [lat, lng]]);
      } else {
        setClickPositions([[lat, lng]]);
      }
    },
  });
  return null;
};

const SatelliteLayerSwitcher = () => {
  const [isSatellite, setIsSatellite] = useState(false);
  const map = useMapEvents({
    zoomend() {
      setIsSatellite(map.getZoom() >= 17);
    },
  });
  {/* //Map coordinate update */}
  return (
    <>
      {!isSatellite && (
        <TileLayer
          attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={22}
        />
      )}
      {isSatellite && (
        <TileLayer
          attribution="Map data &copy; Google"
          url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
          subdomains={["mt0", "mt1", "mt2", "mt3"]}
          maxZoom={22}
        />
      )}
    </>
  );
};



// 14-10

const FitMapToCoordinates = ({ clickPositions }) => {
  const map = useMap();

  useEffect(() => {
    if (!clickPositions || clickPositions.length === 0) {
      return;
    }

    const validPositions = clickPositions
      .filter(
        (pos) =>
          Array.isArray(pos) &&
          pos.length >= 2 &&
          Number.isFinite(Number(pos[0])) &&
          Number.isFinite(Number(pos[1]))
      )
      .map((pos) => [Number(pos[0]), Number(pos[1])]);

    if (validPositions.length === 2) {
      // Automatically show both selected points
      map.fitBounds(validPositions, {
        padding: [40, 40],
        maxZoom: 16,
        animate: true,
      });
    } else if (validPositions.length === 1) {
      // Show the map around a single selected point
      map.setView(validPositions[0], 16, {
        animate: true,
      });
    }
  }, [map, clickPositions]);

  return null;
};


const Mapfunction = () => {
  
  const context = useContext(AdminContext);
  const { CreateMapCoordinateforProject } = context;
  const { id } = useParams();
  const nav = useNavigate();
  const location = useLocation();
  const isProgressReport = location.state?.from === "ProgressReport";
  console.log("Project Id:", id);
  // Selected two points from map
  const [clickPositions, setClickPositions] = useState([]);
  useEffect(() => {
    const savedLocation = sessionStorage.getItem("ProjectMapLocation");
    if (savedLocation) {
      try {
        const parsed = JSON.parse(savedLocation);
        if (parsed.StartCoordinates && parsed.EndCoordinates) {
          setClickPositions([parsed.StartCoordinates, parsed.EndCoordinates]);
        }
      } catch (err) {
        console.log(err);
      }
    }
  }, []);
  const [FetchedCoordinates, setFetchedCoordinates] = useState([]);
  // Construction Type
  const [typeofConstruction, setTypeofConstruction] = useState("Road");
  // Map Click Component
  // const MapClickHandler = () => {
  //   useMapEvents({
  //     click(e) {
  //       const { lat, lng } = e.latlng;
  //       if (clickPositions.length < 2) {
  //         setClickPositions([...clickPositions, [lat, lng]]);
  //       } else {
  //         // Reset after third click
  //         setClickPositions([[lat, lng]]);
  //       }
  //     },
  //   });

  //   return null;
  // };
//double click map
//   const MapClickHandler = () => {
//   useMapEvents({
//     click(e) {
//       const { lat, lng } = e.latlng;

//       if (clickPositions.length < 2) {
//         if (clickPositions.length === 1) {
//           const [prevLat, prevLng] = clickPositions[0];
//           const distance = Math.sqrt(
//             Math.pow(lat - prevLat, 2) + Math.pow(lng - prevLng, 2)
//           );

//           // Same/almost-same point clicked twice (double-click case)
//           if (distance < 0.00001) {
//             alert("Start and End point cannot be the same. Please select a different point.");
//             return; // point add hi nahi hoga, state untouched
//           }
//         }
//         setClickPositions([...clickPositions, [lat, lng]]);
//       } else {
//         setClickPositions([[lat, lng]]);
//       }
//     },
//   });

//   return null;
// };
  let polygonPositions = [];
  if (clickPositions.length === 2) {
    const startPosition = clickPositions[0];
    const endPosition = clickPositions[1];
    // Direction calculation
    const dx = endPosition[1] - startPosition[1];
    const dy = endPosition[0] - startPosition[0];
    const length = Math.sqrt(dx * dx + dy * dy);
    const ux = -dy / length;
    const uy = dx / length;
    // Road width adjustment
    const corner1 = [
      startPosition[0] + ux * 0.0002,
      startPosition[1] + uy * 0.0006,
    ];
    const corner2 = [
      startPosition[0] - ux * 0.0,
      startPosition[1] - uy * 0.0014,
    ];
    const corner3 = [
      endPosition[0] - ux * 0.0003,
      endPosition[1] - uy * 0.0009,
    ];
    const corner4 = [endPosition[0] + ux * 0.0, endPosition[1] + uy * 0.0009];
    polygonPositions = [corner1, corner2, corner3, corner4];
  }
  // Fetch Existing Coordinates From Database
  useEffect(() => {
    const loadCoordinate = async () => {
      const projectId = id || sessionStorage.getItem("MapProjectId");
      if (!projectId) return;
      try {
        const res = await CreateMapCoordinateforProject(
          "FetchCoordinateForProject",
          projectId,
        );
        if (res && res.StartCoordinates && res.EndCoordinates) {
          setClickPositions([res.StartCoordinates, res.EndCoordinates]);
        }
      } catch (err) {
        console.log(err);
      }
    };
    loadCoordinate();
  }, [id]);
  // Submit Selected Coordinate
  const SubmitCoordinateSelected = async () => {
    console.log("Selected Points :", clickPositions);
    if (clickPositions.length !== 2) {
      alert("You have not Selected Area !!!");
      return;
    }
    const start = clickPositions[0];
    const end = clickPositions[1];
    const projectId = id || sessionStorage.getItem("MapProjectId");
    try {
      if (projectId) {
        // Editing an existing project -> save straight to DB
        const res = await CreateMapCoordinateforProject(
          "InsertOrUpdateCoordinateforProject",
          { start, end, polygon: polygonPositions, ProjectId: projectId },
        );
        if (res?.message) {
          alert(res.message);
        }
      } else {
        // New project (no ProjectId yet) -> hold it until the project itself is saved
        const oldMapData =
          JSON.parse(sessionStorage.getItem("ProjectMapLocation")) || {};

        const mapData = {
          ...oldMapData,
          StartCoordinates: start,
          EndCoordinates: end,
          PolygonCoordinates: polygonPositions,
        };
        sessionStorage.setItem("ProjectMapLocation", JSON.stringify(mapData));
      }
      if (id) {
        nav(`/AdminDashboard/CreateProject/${id}`);
      } else {
        nav("/AdminDashboard/CreateProject");
      }
    } catch (err) {
      console.error("Insert Coordinate Error :", err);
      if (id) {
        nav(`/AdminDashboard/CreateProject/${id}`);
      } else {
        nav("/AdminDashboard/CreateProject");
      }
    }
  };
  // Back Button
  const CancelMapSubmission = () => {
    const shouldclose = window.confirm("Are you Sure ?");
    if (shouldclose) {
      alert("Location Selection Cancelled !!");
      if (isProgressReport) {
        nav("/AdminDashboard/ProgressReport");
      } else if (id) {
        nav(`/AdminDashboard/CreateProject/${id}`);
      } else {
        nav("/AdminDashboard/CreateProject");
      }
    }
  };

  // Clear Selected Points
  const ResetClickPoint = () => {
    setClickPositions([]);
  };

  // Satellite Layer Switcher
//   const SatelliteLayerSwitcher = () => {
//     const [isSatellite, setIsSatellite] = useState(false);

//     const map = useMapEvents({
//       zoomend() {
//         const zoom = map.getZoom();
//         setIsSatellite(zoom >= 17);
//       },
//     });

//     return (
//       <>
//         {!isSatellite && (
//           <TileLayer
//             attribution="&copy; OpenStreetMap contributors"
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             maxZoom={22}
//           />
//         )}
//         {isSatellite && (
//           <TileLayer
//             attribution="Map data &copy; Google"
//             url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
//             subdomains={["mt0", "mt1", "mt2", "mt3"]}
//             maxZoom={22}
//           />
//         )}
//       </>
//     );
//   };

//   const formatCoord = (pos) => (pos ? `${pos[0]}, ${pos[1]}` : "");

// const selectStyle = {
//   borderRadius: "10px",
//   width: "100%",
//   padding: "10px 14px",
//   border: "1px solid #c2d4e9",
//   fontSize: "13px",
//   fontWeight: "500",
//   background: "#fff",
// };

// const labelStyle = {
//   fontSize: "13px",
//   fontWeight: "600",
//   color: "#000",
//   marginBottom: "6px",
// };

  return (
    <>
    
      <div
        className="col-12"
        style={{
          background: "white",
          maxHeight: "88vh",
          overflowY: "scroll",
          paddingBottom: "40px",
        }}
      >
          {/* //Map coordinate update */}
      <div
  className="col-11 m-auto my-4 p-4"
  style={{
    background: "#EAF2FB",
    borderRadius: "16px",
    border: "1px solid #d5e3f0",
  }}
>
  <div className="row g-3">
    <div className="col-4">
      <p style={labelStyle}>Type of Construction:</p>
      {/* <select
        className="form-select"
        value={typeofConstruction}
        onChange={(e) => setTypeofConstruction(e.target.value)}
        disabled={isProgressReport}
        style={selectStyle}
      > */}

        {/* 05-10 */}
      <select
  className="form-select"
  value={typeofConstruction}
  onChange={(e) => setTypeofConstruction(e.target.value)}
  disabled={isProgressReport}
  style={selectStyle}
>
    
        <option value="Road">Road Construction</option>
        <option value="Metro">Metro Construction</option>
        <option value="Water">Water Line Construction</option>
        <option value="Drainage">Drainage Line Construction</option>
      </select>
    </div>

    <div className="col-4">
      <p style={labelStyle}>Start Coordinates:</p>
      <div style={boxStyle}>
        {clickPositions[0]
          ? formatCoord(clickPositions[0])
          : "Click on map to select start point"}
      </div>
    </div>

    <div className="col-4">
      <p style={labelStyle}>End Coordinates:</p>
      <div style={boxStyle}>
        {clickPositions[1]
          ? formatCoord(clickPositions[1])
          : "Click on map to select end point"}
      </div>
    </div>
  </div>
</div>
        {/* MAP SECTION */}
        <div
          className="m-auto"
          style={{
            height: "450px",
            width: "92%",
            background: "white",
            borderRadius: "14px",
            border: "1px solid #d5e3f0",
            padding: "12px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.10)",
          }}
        >
          <MapContainer
            center={[18.5615, 73.7685]}
            zoom={15}
            style={{ height: "100%", width: "100%", borderRadius: "10px" }}
          >
            <SatelliteLayerSwitcher />
              {/* 14-10 Automatically center map on selected coordinates */}
  <FitMapToCoordinates clickPositions={clickPositions} />
            {/* //Map coordinate update */}
           {!isProgressReport && (
  <MapClickHandler
    clickPositions={clickPositions}
    setClickPositions={setClickPositions}
  />
)}
            {/* Selected Points Marker */}
            {clickPositions.map((pos, index) => (
              <Marker key={index} position={pos}>
                <Popup>
                  {index === 0
                    ? `${typeofConstruction} Start Point`
                    : `${typeofConstruction} End Point`}
                </Popup>
              </Marker>
            ))}

            {/* Existing Database Polygon (other proposals, if fetched) */}
            {FetchedCoordinates &&
              FetchedCoordinates.map((val, index) => (
                <Polygon
                  key={index}
                  positions={val.Area}
                  pathOptions={{ color: "blue", weight: 2, fillOpacity: 0.8 }}
                >
                  <Popup>{val.ProposalID}</Popup>
                </Polygon>
              ))}

            {/* New / Existing Selected Area */}
            {clickPositions.length === 2 && (
              <>
                <Polyline
                  positions={clickPositions}
                  pathOptions={{
                    color:
                      typeofConstruction === "Road"
                        ? "blue"
                        : typeofConstruction === "Metro"
                          ? "red"
                          : typeofConstruction === "Water"
                            ? "aqua"
                            : "brown",
                    weight: typeofConstruction === "Metro" ? 4 : 2,
                    dashArray:
                      typeofConstruction === "Metro"
                        ? "10,10"
                        : typeofConstruction === "Drainage"
                          ? "2,6"
                          : undefined,
                  }}
                />
                <Polygon
                  positions={polygonPositions}
                  pathOptions={{
                    color:
                      typeofConstruction === "Road"
                        ? "green"
                        : typeofConstruction === "Metro"
                          ? "red"
                          : typeofConstruction === "Water"
                            ? "aqua"
                            : "brown",
                    weight: 2,
                    fillOpacity: 0.4,
                    dashArray:
                      typeofConstruction === "Drainage" ? "2,6" : undefined,
                  }}
                >
                  <Popup>Proposal for: {typeofConstruction} Area</Popup>
                </Polygon>
              </>
            )}
          </MapContainer>
        </div>

        {/* BUTTON SECTION — edit actions only for Create/Edit Project flow */}
        {!isProgressReport && (
          <div className="col-12 text-center my-4">
            {/* Submit Button */}
            <button
              className="btn btn-success px-3 mx-3"
              style={{ fontSize: "16px" }}
              onClick={SubmitCoordinateSelected}
            >
             <img
  src={submitIcon}
  alt="Submit"
  style={{ width: "24px", height: "24px" }}
  className="my-auto me-1"
/>
              Submit
            </button>
            {/* Clear Button */}
            <button
              className="btn btn-danger px-3 mx-3 fw-bold"
              style={{
                fontSize: "16px",
                backgroundColor: "#c1272d",
                color: "white",
                border: "1px solid #c1272d",
                transition: "all 0.3s ease-in-out",
              }}
              onClick={ResetClickPoint}
            >
          <img
  src={cancelIcon}
  alt="Clear"
  style={{ width: "24px", height: "24px" }}
  className="my-auto me-1"
/>
              Clear
            </button>

            {/* Back Button */}
            <button
              className="btn btn-primary px-3 mx-3"
              style={{
                fontSize: "16px",
                backgroundColor: "#0071bc1A",
                color: "#0071bc",
                border: "1px solid #0071bc",
                transition: "all 0.3s ease-in-out",
              }}
              onClick={CancelMapSubmission}
            > <img src={"/Back-Arrow-32.jpg"} alt="Back Icon" className="Back-icon" style={{ width: "18px", width: "18px", marginRight: "7px" }} />
              Back
            </button>
          </div>
        )}

        {/* Simple close/back for the Progress Report view-only trip */}
        {isProgressReport && (
          <div className="col-12 text-center my-4">
            <button
              className="btn btn-primary px-3 mx-3"
              style={{
                fontSize: "16px",
                backgroundColor: "#0071bc1A",
                color: "#0071bc",
                border: "1px solid #0071bc",
              }}
              onClick={() => nav("/AdminDashboard/ProgressReportOutwordList")}
            >
              Back
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Mapfunction;


